/**
 * A catalog supplier's logo, beside its name (BLU-1501). The name is always
 * there, so the logo is decorative (`alt=""`). No usable logo, or one that fails
 * to load, renders nothing at all: never an empty box or a broken-image mark.
 *
 * A fixed box, so the name beside it does not move while the logo loads. Logos
 * come in every shape: it sits to the left, whole, and is never stretched.
 */
import { useState } from 'react';
import { cn } from '@/lib/utils';
import { supplierLogoSrc } from '../lib/catalog-links';

export function SupplierLogo({ url, className }: { url: string | null | undefined; className?: string }) {
  // The address that failed: another address gets its own try.
  const [failed, setFailed] = useState<string | null>(null);
  const src = supplierLogoSrc(url);
  if (!src || src === failed) return null;

  return (
    <img
      src={src}
      alt=""
      loading="lazy"
      decoding="async"
      className={cn('h-6 w-16 shrink-0 object-contain object-left', className)}
      onError={() => setFailed(src)}
    />
  );
}
